import Document from '@/views/document'
import ListDocument from '@/views/document/list'
// import CreateDocument from '@/views/document/create'
// import EditDocument from '@/views/document/edit'
import EditDocumentItem from '@/views/document-item/edit'
import ViewDocumentItem from '@/views/document-item/view'
import IndexDocumentItem from '@/views/document-item/updateParent'

export default {
  path: 'document',
  component: Document,
  redirect: 'document/list',
  name: 'document.title',
  children: [
    {
      path: 'list',
      name: 'document.list',
      component: ListDocument
    },
    {
      path: 'view/:document_id',
      name: 'document.edit',
      component: EditDocumentItem
    },
    {
      path: 'view/:document_id/index',
      name: 'document.document_item.index',
      component: IndexDocumentItem
    },
    {
      path: 'view/:document_id/view',
      name: 'document.attribute.view',
      component: ViewDocumentItem
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/documents/document.js